import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-progress-bar',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="console-progress-container">
      <span class="progress-brackets">[<span class="progress-fill" [style.width]="progress + '%'"></span>]</span>
      <span class="progress-value">{{ progress }}%</span>
      <span class="progress-separator">|</span>
      <span class="progress-label">{{ label }}</span>
    </div>
  `,
  styles: [`
    :host {
      display: block; /* Ensures the component takes full width available */
      font-family: 'Consolas', 'Courier New', monospace; /* Console-like font */
      color: #28a745; /* Green text */
      /* Removed background-color: #1a1a1a; for white background */
      padding: 5px;
      border-radius: 4px;
    }
    .console-progress-container {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 0.9em;
    }
    .progress-brackets {
      flex-shrink: 0; /* Prevent brackets from shrinking */
      width: 150px; /* Fixed width for the bar area */
      height: 1em; /* Height of the bar */
      border: 1px solid #28a745; /* Green border for brackets */
      display: flex;
      align-items: center;
      padding: 0 2px; /* Small padding inside brackets */
    }
    .progress-fill {
      background-color: #28a745; /* Green fill */
      height: 80%; /* Slightly smaller than bracket height */
      transition: width 0.3s ease-in-out;
      display: block; /* Make it a block for width to apply */
    }
    .progress-value {
      flex-shrink: 0;
      min-width: 40px; /* Ensure space for 100% */
      text-align: right;
    }
    .progress-separator {
      flex-shrink: 0;
      color: #555; /* Darker separator */
    }
    .progress-label {
      flex-grow: 1; /* Take remaining space */
      white-space: nowrap; /* Prevent label from wrapping */
      overflow: hidden; /* Hide overflow */
      text-overflow: ellipsis; /* Add ellipsis if text is too long */
    }
  `]
})
export class ProgressBarComponent implements OnChanges {
  @Input() progress: number = 0;
  @Input() label: string = 'Progress';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['progress']) {
      if (this.progress > 100) {
        this.progress = 100;
      }
      if (this.progress < 0) {
        this.progress = 0;
      }
    }
  }
}
